<template>
  <footer>
    <div class="container footer_inner">
      <div class="footer_link">
        <ul>
          <li>
            <router-link to="/footer/legalnotice">{{
              $t("common.legalNotice")
            }}</router-link>
          </li>
          <li>
            <router-link to="/footer/termsofuse">{{
              $t("common.termsOfUse")
            }}</router-link>
          </li>
          <li>
            <router-link to="/footer/privacypolice">{{
              $t("common.privacyPolice")
            }}</router-link>
          </li>
          <!-- <li>
            <a href="#">{{ $t("common.downloadApp") }}</a>
          </li> -->
        </ul>
      </div>
      <div class="footer_right_link">
        <div class="family_link">
          <dl>
            <dt>{{ $t("common.familyLink") }}</dt>
            <dd>
              <a href="https://www.facebook.com/hd-hyundai-infracore" target="_blank"
                >Facebook</a
              >
            </dd>
            <dd>
              <a
                href="https://www.instagram.com/hd.hyundai_infracore/"
                class="link_instargram"
                target="_blank"
                >Instargram</a
              >
            </dd>
            <dd>
              <a
                href="https://www.linkedin.com/company/hd-hyundai-infracore"
                class="link_linked"
                target="_blank"
                >InkedIn</a
              >
            </dd>
          </dl>
        </div>
        <!----------------------------------------------------Related Link--------------------------------------------------------->
        <div v-if="linkList != null" class="r_site_wrap">
          <div class="r_site_box dropdown dropup">
            <button
              class="r_s_toggle_bt"
              type="button"
              id="dropdownMenuButton2"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Related Sites
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <li v-for="(link, index) in linkList" :key="index">
                <a class="dropdown-item" :href="link.linkUrl" target="_blank">
                  {{
                    link.linkName.length > 25
                      ? link.linkName.substring(0, 22) + "..."
                      : link.linkName
                  }}</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="footer_bottom">
        <h3>HD HYUNDAI INFRACORE</h3>
        <p>© 2021 Global Service Information System</p>
      </div>
    </div>
  </footer>
</template>

<script>
import { getRelatedLinkList } from "@/api/relatedlink";
export default {
  data() {
    return {
      linkList: [],
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        const { data } = await getRelatedLinkList();
        this.linkList = data.linkList;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style></style>
